module.exports = __webpack_public_path__ + "static/media/notifications_icon_without_dot.88e1f826.svg";